<template>
	<modal ref="modal" size="modal-lg">
		<template #title>Member Information</template>
		<template #body>
			<div v-if="investment!=null" class="row mb-3">
				<div class="col-md-12">
					<div class="form-group mb-4">
						<h4 class="text-center fw-bold">
							<span v-if="investment.remit_status=='S'" class="text-success">TRANSFERED</span>
							<span v-else class="text-danger">NOT YET TRANSFERED</span>
						</h4>
					</div>
				</div>
				<div class="col-md-12">
					<p class="h5 text-center">{{investment.invest_code}}-{{investment.invest_name}}</p>
				</div>
				<div class="col-md-5">
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.invest_source}}</div>
						<label class="form-label">SOURCE</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.txnid}}</div>
						<label class="form-label">TXNID</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.refid}}</div>
						<label class="form-label">REFID</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.status}}</div>
						<label class="form-label">Status</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.remit_status}}</div>
						<label class="form-label">Remit Status</label>
					</div>
				</div>
				<div class="col-md-7">
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.email}}</div>
						<label class="form-label">Email Address</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.fname}} {{investment.mname1}} {{investment.lname}}</div>
						<label class="form-label">Member's Name</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.current_rank}}</div>
						<label class="form-label">Subscription</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.mobile}}</div>
						<label class="form-label">Mobile</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{investment.expiry}}</div>
						<label class="form-label">Expiry</label>
					</div>
				</div>
			</div>
			<div v-else class="p-5 text-center">
				<p class="h4 m-0">No Record Found</p>
			</div>
		</template>
		<template #footer>
			<span v-if="investment!=null">
				<!-- <button v-if="investment.remit_status!='S'"
					@click="remitAmount"
					type="button"
					class="btn btn-alt-success"
					:disabled="form.processing"
				>
					<i v-if="!form.processing" class="fa fa-check-circle me-1"></i>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark me-1" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
					</span>
					<span>Remit</span>
				</button> -->
			</span>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				<i class="fa fa-times me-1"></i>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
	import { watch, ref } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';

	export default {
		props:{
			apiResponse : Object
		},
		setup(props){

			const modal 	= ref(null);
			const action 	= ref('transfer');

			const investment = ref(null);

			const form = useForm({
				invest_trans_uuid 	: null,
				invest_uuid 		: null,
			});

			const toggleModal = () => { modal.value.toggleModal(); };


			const setInvest = (data)=>{ 
				investment.value 		= data; 
				form.invest_trans_uuid 	= investment.value.invest_trans_uuid; 
				form.invest_uuid 		= investment.value.invest_uuid; 
			}

			const remitAmount = ()=>{
				action.value 			= 'transfer';
				
				// form.put("verified/"+member.value.invest_uuid,{},{
				// 	only:['approvals','api_response'],
				// });

			}

			watch(()=>props.apiResponse, (value) => {
				if(value.result=="success")
				{
				

				}
			})

			return{
				action,
				modal,
				form,
				toggleModal,
				investment,
				setInvest,
				remitAmount
			}
		}
	}

</script>